import React from 'react';
import {createBrowserRouter,RouterProvider,redirect} from "react-router-dom";
import CategoryMain,{loader as CategoryLoader} from './CategoryMain.js';
import Biography,{loader as BiographyLoader} from './Biography.js';
import NewsItems,{loader as NewItemLoader} from "./NewsItems.js";
import Liegen from './Liegen.js';
import Links ,{loader as LinksLoader} from "./Links.js";
import Contact from "./Contact.js";
import CategoryImageGrid ,{loader as CatGrpLoader} from "./CategoryImageGrid.js";
import ErrorBoundary from './ErrorBoundry';
import Main from './Main.jsx';
import {QueryClientProvider, QueryClient} from 'react-query';

const queryClient = new QueryClient();

const router = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
    children:[
      {
        path: "",
        element: <NewsItems />,
        loader: NewItemLoader(queryClient),
      },
      {
        path: "Biography",
        element: <Biography />,
        loader: BiographyLoader(queryClient),
      },
      {
        path: "Contact",
        element: <Contact />,
      },
      {
        path: "NewsItems",
        element: <NewsItems />,
        loader: NewItemLoader(queryClient),
      },
      {
        path: "Links",
        element: <Links />,
        loader: LinksLoader(queryClient),
      },
      {
        path: "Installations",
        element: <CategoryImageGrid />,
        loader: CatGrpLoader(queryClient,"Installations")
      },
      {
        path: "Pictures",
        element: <CategoryImageGrid />,
        loader: CatGrpLoader(queryClient,"Pictures")
      },
      {
        path: "Objects",
        element: <CategoryImageGrid />,
        loader: CatGrpLoader(queryClient,"Objects")
        
      },
      {
        path: "Pictures/:catId",
        element: <CategoryMain />,
        loader: CategoryLoader(queryClient),
      },
      {
        path: "Installations/:catId",
        element: <CategoryMain />,
        loader: CategoryLoader(queryClient),
      },
      {
        path: "Installations/Liegen",
        element: <Liegen />,
      },
      {
        path: "Objects/:catId",
        element: <CategoryMain />,
        loader: CategoryLoader(queryClient),
      },
      // Old internal URLs, still indexed by google, will be redirected to the new URLs. These can be removed after google forgets them
      {
        path: "CategoryImageList/CAT_GRP_INSTALLATION",
        loader: async () => {
          return redirect("/Installations");
        }
      },
      {
        path: "CategoryImageList/CAT_GRP_PICTURES",
        loader: async () => {
          return redirect("/Pictures");
        }
      },
      {
        path: "CategoryImageList/CAT_GRP_OBJECTS",
        loader: async () => {
          return redirect("/Objects");
        }
      }
    ]
  }]);

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router}/>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}

export default App